import {
  IEdge,
} from '../fetchedData/layoutData';

const getLookupTable = (
    edges: IEdge[],
  ): Record<string, number[]> => {

  const unsorted: Record<string, number[]> = {};

  for (const {source, target} of edges) {
    const retrievedSource = unsorted[source];
    if (retrievedSource === undefined) {
      unsorted[source] = [];
    }
    unsorted[source].push(target);

    const retrievedTarget = unsorted[target];
    if (retrievedTarget === undefined) {
      unsorted[target] = [];
    }
    unsorted[target].push(source);
  }

  const sorted: Record<string, number[]> = {};
  for (const [key, values] of Object.entries(unsorted)) {
    const sortedValues = values.sort();
    sorted[key] = sortedValues;
  }

  return sorted;
};

export default getLookupTable;
